import { defineStore } from "#q-app"
import { createPinia } from "pinia"
import { markRaw } from "vue"
import PocketBase from "pocketbase"
import type { TypedPocketBase } from "@/pocketbase-types"

/*
 * If not building with SSR/SSG mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default defineStore((/* { ssrContext } */) => {
  const pinia = createPinia()
  const pocketbase = new PocketBase("/")

  // You can add Pinia plugins here
  // pinia.use(SomePiniaPlugin)
  pinia.use(({ store }) => {
    store.pb = markRaw(pocketbase)
  })

  return pinia
})

declare module "pinia" {
  export interface PiniaCustomProperties {
    pb: TypedPocketBase
  }
}
